import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { Property } from '@app/shared/interfaces';
import { ParentChildInteractionType, PropertiesService } from '@app/shared/services/properties/properties.service';
import { SegmentEvent, SegmentIoService } from '@app/shared/services/segmentIo/segment-io.service';

type Stage = 'selectParent' | 'selectInteraction' | 'reviewConfirmation' | 'success';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-parent-child-property-setup',
  styleUrls: ['./dialog-parent-child-property-setup.component.scss'],
  templateUrl: './dialog-parent-child-property-setup.component.html',
})
export class DialogParentChildPropertySetupComponent {
  selectedParent: number;
  interactionType: ParentChildInteractionType | null = null;

  stages: Stage[] = ['selectParent', 'selectInteraction', 'reviewConfirmation', 'success'];
  selectedStage: Stage;

  saving = false;
  updatedSecondaryUsers: { id: number; name: string }[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public dialogData: {
      properties: Property[];
    },
    public dialogRef: MatDialogRef<DialogParentChildPropertySetupComponent>,
    private router: Router,
    private propertiesService: PropertiesService,
    private segmentIoService: SegmentIoService
  ) { }

  ngOnInit() {
    this.selectedStage = this.stages[0];
  }

  progressStage() {
    this.segmentIoService.track(this.segmentEvent, {});

    const currentIndex = this.stages.indexOf(this.selectedStage);
    this.selectedStage = this.stages[currentIndex + 1];

    if (this.selectedStage === 'selectInteraction' && this.dialogData.properties.length < 3) {
      // skip over the behavior stage if we have less than 3 properties overall
      this.interactionType = 'none-blocking';
      this.progressStage();
    }
  }

  private get segmentEvent() {
    switch (this.selectedStage) {
      case 'success':
        return SegmentEvent.ParentChildConfigStageSuccessComplete;
      case 'selectParent':
        return SegmentEvent.ParentChildConfigStageSelectParentComplete;
      case 'selectInteraction':
        return SegmentEvent.ParentChildConfigStageSelectInteractionComplete;
      case 'reviewConfirmation':
        return SegmentEvent.ParentChildConfigStageReviewConfirmationComplete;
      default:
        return null;
    }
  }

  goBack() {
    const currentIndex = this.stages.indexOf(this.selectedStage);
    this.selectedStage = this.stages[currentIndex - 1];
  }

  saveRelationship() {
    this.saving = true;

    this.propertiesService
      .createParentChildRelationship(
        this.dialogData.properties.map((prop) => prop.id),
        this.selectedParent,
        this.interactionType
      )
      .subscribe(
        (res) => {
          this.updatedSecondaryUsers = res.data?.updated_users;
          this.segmentIoService.track(SegmentEvent.ParentChildConfigCompleted, {});
          this.saving = false;
          this.selectedStage = 'success';
        },
        (err) => {
          this.saving = false;
        }
      );
  }

  redirectToCalendar() {
    this.router.navigate(['/calendar']);
    this.dialogRef.close();
  }
}
